import { ID_LEITE_VACA, CRESCIMENTO_TERMINACAO, BEZERRO, VACA, FEMEA, MACHO, MACHO_CASTRADO, ZEBUINO, CRUZADO_CORTE, CRUZADO_LEITE, LACTANTE, GESTANTE_LACTANTE, PASTO } from '@/utils/types.js'
import CryptoJS from 'crypto-js'
import Vue from 'vue'
import Swal from 'sweetalert2'
import router from '@/router'
import store from '@/store'
import { getAcessoModulo as getAcessoModuloAction } from '../store/auth/actions'
import { relatorioFinanceiro } from '../store/dietas/actions'
import moment from 'moment'
import _ from 'lodash';
import cache from '../plugins/cache'
import { getString } from '../lang/Strings'
import { API_BASE_URL } from '@/plugins/axios'

export const BACKGROUND_LIST = ['img/bg/1.png', 'img/bg/2.png', 'img/bg/3.png', 'img/bg/4.png', 'img/bg/5.png', 'img/bg/6.png', 'img/bg/7.png', 'img/bg/8.png', 'img/bg/9.png', 'img/bg/10.png', 'img/bg/11.jpg', 'img/bg/12.jpg', 'img/bg/13.jpg', 'img/bg/14.jpg', 'img/bg/15.jpg', 'img/bg/16.jpg', 'img/bg/17.jpg', 'img/bg/18.jpg', 'img/bg/19.jpg']
const apiBaseUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL : `${API_BASE_URL}/`
export const linkRenderRelPDF = (url) => {
  return `${apiBaseUrl}renderRelPDF?url=${url}`
}
export const linkRenderRelCSV = (url) => {
  return `${apiBaseUrl}renderRelCSV?url=${url}`
}
export const btoa = (data) => {
  return Buffer.from(data).toString('base64')
}
export const atob = (data) =>{
  return Buffer.from(data, 'base64').toString('utf8')
}
export function median (numbers) {
  const sorted = numbers.slice().sort((a, b) => a - b)
  const middle = Math.floor(sorted.length / 2)

  if (sorted.length % 2 === 0) {
    return (sorted[middle - 1] + sorted[middle]) / 2
  }

  return sorted[middle]
}
export var stats = {
  max: function (array) {
    return Math.max.apply(null, array)
  },

  min: function (array) {
    return Math.min.apply(null, array)
  },

  range: function (array) {
    return this.max(array) - this.min(array)
  },

  midrange: function (array) {
    return this.range(array) / 2
  },

  sum: function (array) {
    var num = 0
    for (var i = 0, l = array.length; i < l; i++) num += array[i]
    return num
  },

  mean: function (array) {
    return this.sum(array) / array.length
  },

  median: function (array) {
    array.sort(function (a, b) {
      return a - b
    })
    var mid = array.length / 2
    var res = mid % 1 ? array[mid - 0.5] : (array[mid - 1] + array[mid]) / 2

    return !res || isNaN(res) ? 0.0 : res
  },

  modes: function (array) {
    if (!array.length) return []
    var modeMap = {},
      maxCount = 1,
      modes = [array[0]]

    array.forEach(function (val) {
      if (!modeMap[val]) modeMap[val] = 1
      else modeMap[val]++

      if (modeMap[val] > maxCount) {
        modes = [val]
        maxCount = modeMap[val]
      } else if (modeMap[val] === maxCount) {
        modes.push(val)
        maxCount = modeMap[val]
      }
    })

    return modes[modes.length - 1]
  },

  variance: function (array) {
    var mean = this.mean(array)
    return this.mean(array.map(function (num) {
      return Math.pow(num - mean, 2)
    }))
  },

  standardDeviation: function (array) {
    return Math.sqrt(this.variance(array))
  },

  meanAbsoluteDeviation: function (array) {
    var mean = this.mean(array)
    return this.mean(array.map(function (num) {
      return Math.abs(num - mean)
    }))
  },

  zScores: function (array) {
    var mean = this.mean(array)
    var standardDeviation = this.standardDeviation(array)
    return array.map(function (num) {
      return (num - mean) / standardDeviation
    })
  }
}
export const sanitizeString = (str) => {
  if (!str) return '';
  if (typeof str !== 'string') str = String(str);
  // trim
  str = str.trim();
  return str.normalize('NFD').replace(/\uFFFD/g, '')
      .replace(/[\u0300-\u036f]/g, '');
}
/**
 * Converts the given value to a floating point number with two decimal places.
 * If the value cannot be parsed as a number, returns 0.
 *
 * @param {any} val - The value to be parsed as a float.
 * @returns {number} The parsed float rounded to two decimal places, or 0 if parsing fails.
 */
export const safeParseFloat = (val) => {
  const num = parseFloat(val);
  return isNaN(num) ? 0 : parseFloat(num.toFixed(2));
}
/**
 * Função para decodificar uma string base64 e sanitizar caracteres especiais
 * Decodes a Base64-encoded string and sanitizes it by removing invalid characters
 * and diacritics.
 *
 * @param {string} base64 - The Base64-encoded string to decode and sanitize.
 * @returns {string} The decoded and sanitized string, or an empty string if input is falsy.
 */
export const base64DecodeSanitarize  = (base64) => {
  if (!base64) {
    return ''
  }
  base64 = atob(base64);
  base64 = base64.replace(/\uFFFD/g, '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  return base64;
}
/**
 *  Função para codificar uma string em base64 e sanitizar caracteres especiais
 * Encodes a string to Base64 and sanitizes it by removing invalid characters
 *  and diacritics.
 *  @param {string|object} str - The string or object to encode and sanitize.
 *  @returns {string} The Base64-encoded and sanitized string, or an empty string if input is falsy.
 *  @example
 *  base64EncodeSanitarize('Hello World!'); // Returns 'SGVsbG8gV29ybGQh'
 */
export const base64EncodeSanitarize = (str) => {
  if (!str) {
    return '';
  }
  // verifica se é json
  if (typeof str === 'object') {
    str = JSON.stringify(str);
  }
  str = str.normalize('NFD').replace(/\uFFFD/g, '')
      .replace(/[\u0300-\u036f]/g, '');
  str = btoa(str);
  return str;
}
export const tableToJSON = (tableID) => {
  var table = document.getElementById(tableID);
  var tableHTML = table.outerHTML.replace(/ /g, '%20');
  var data = [];

  // first row needs to be headers
  var headers = [];
  for (var i=0; i<table.rows[0].cells.length; i++) {
      headers[i] = table.rows[0].cells[i].innerHTML.toLowerCase().replace(/ /gi,'');
  }

  // go through cells
  for (var i=1; i<table.rows.length; i++) {

      var tableRow = table.rows[i];
      var rowData = {};

      for (var j=0; j<tableRow.cells.length; j++) {

          rowData[ headers[j] ] = tableRow.cells[j].innerHTML;

      }

      data.push(rowData);
  }       

  return data;
}
export const exportTableToExcel = (tableID, filename = '') => {
  function htmlToCSV(html, filename) {
    var data = [];
    var rows = html.querySelectorAll("tr");
        
    for (var i = 0; i < rows.length; i++) {
      var row = [], cols = rows[i].querySelectorAll("td, th");
          
      for (var j = 0; j < cols.length; j++) {
        row.push('"' + cols[j].innerText + '"');
      }
              
      data.push(row.join(";")); 		
    }
  
    return data.join('\n')
  }
  var downloadLink;
  var csv_file;
  var dataType = 'application/vnd.ms-excel';
  var tableSelect = document.getElementById(tableID);
  var tableHTML = tableSelect.outerHTML;
  
  /*
  
  // Specify file name
  filename = filename?filename+'.xls':'excel_data.xls';
  
  // Create download link element
  downloadLink = document.createElement("a");
  
  document.body.appendChild(downloadLink);
  */
  var data = htmlToCSV(tableSelect, filename)
  csv_file = new Blob([data], {type: "text/csv"});

	downloadLink = document.createElement("a");

	downloadLink.download = filename;

	downloadLink.href = window.URL.createObjectURL(csv_file);

	downloadLink.style.display = "none";

	document.body.appendChild(downloadLink);

	downloadLink.click();
  return tj
  if(navigator.msSaveOrOpenBlob && false){
      var blob = new Blob(['\ufeff', tableHTML], {
          type: dataType
      });
      navigator.msSaveOrOpenBlob( blob, filename);
  }else{
      // Create a link to the file
      downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
  
      // Setting the file name
      downloadLink.download = filename;
      
      //triggering the function
      downloadLink.click();
  }
}
export const exportCSV = (stringData) => {
  stringData = "data:text/csv;charset=utf-8," + stringData;
  var encodedUri = encodeURI(stringData);
  var link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", `dados_${new Date().getTime()}.csv`);
  document.body.appendChild(link); // Required for FF
  link.click();
  document.body.removeChild(link); 
}
export const composicao = (...fn) => {
  return (...args) => {
    return fn.reduce((acc, fn) => {
      return fn(acc)
    }, ...args)
  }
}
export const transposeTable = (tbody, newContainerType = "tbody") => {
  const rows = Array.from(tbody.querySelectorAll("tr"))
  const newTbody = document.createElement(newContainerType)

  for (let rowIdx = 0; rowIdx < rows.length; rowIdx++) {
    const row = rows[rowIdx]
    const cells = Array.from(row.querySelectorAll("td, th"))

    for (let cellIdx = 0; cellIdx < cells.length; cellIdx++ ) {
      const cell = cells[cellIdx]
      // const newRow = newRows[cellIdx] || document.createElement("tr")
      const newRow = newTbody.children[cellIdx] || document.createElement("tr")
      if (!newTbody.children[cellIdx]) {
      	newTbody.appendChild(newRow)
      }
      newRow.appendChild(cell.cloneNode(true))
    }
  }
  newTbody.id = tbody.id
  // Do live DOM manipulations only once for performance
  tbody.parentElement.appendChild(newTbody)
  tbody.parentElement.removeChild(tbody)
}
export const groupBy = (xs, f) => {
  return xs.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {})
}
/**
 * Resize a base 64 Image
 * @param {String} base64 - The base64 string (must include MIME type)
 * @param {Number} newWidth - The width of the image in pixels
 * @param {Number} newHeight - The height of the image in pixels
 */
export const resizeBase64Img = (base64, newWidth, newHeight) => {
  return new Promise((resolve, reject) => {
    var canvas = document.createElement('canvas')

    let context = canvas.getContext('2d')
    let img = document.createElement('img')
    img.src = base64
    img.onload = function () {
      context.scale(newWidth / img.width, newHeight / img.height)
      context.drawImage(img, 0, 0)
      resolve(canvas.toDataURL())
    }
  })
}
export const createMD5 = (conteudo) => {
  return CryptoJS.MD5(conteudo).toString()
}
export const limpaLocalStorage = (exceptions = null) => {
  if (!exceptions) exceptions = ['idioma', 'desktopApp', 'cookie:accepted', 'clientToken', 'dark', 'rememberLogin', 'adm.valid', 'cookie:accepted', 'cookie_consent']
  var _xLen
  var _x
  for (_x in localStorage) {
    if (!localStorage.hasOwnProperty(_x)) {
      continue
    }
    // _xLen = ((localStorage[_x].length + _x.length) * 2)
    if (exceptions.includes(_x)) continue
    localStorage.removeItem(_x)
  }
  // remove o cache indexedDB
  cache.clearAllForLogout()
}

export const mostraAnuncio30s = (timer = 30) => {
  const ev = new CustomEvent('exibir-anuncio-30s', {
    detail: {
      timer
    }
   })
  window.dispatchEvent(ev);
}

export const normaliza = (state) => {
  const idioma = state.app.idioma
  const alimentos = state.app.alimentos_selecionados
  const animal = state.app.animal
  const exigencias = state.app.exigencias
  for (let att in animal) {
    if (att === 'ganho_medio_diario') {
          continue
    }
    animal[att].valor_raw = parseString(animal[att].valor, idioma)
  }
  state.app.alimentos_selecionados.forEach((el, index) => {
    let alimento = alimentos[index]
    let nutrientes = Object.assign({}, state.app.alimentos_selecionados[index].nutrientes)
    for (let nutriente in nutrientes) {
      let val = (alimento.alterado || alimento.nutrientes_raw === undefined || alimento.nutrientes_raw[nutriente] === undefined) ? parseFloat(alimento.nutrientes[nutriente]) : alimento.nutrientes_raw[nutriente]
      alimento.nutrientes[nutriente] = val
    }
  })
  for (let exigencia in exigencias) {
    exigencias[exigencia].minimo_raw = (typeof (exigencias[exigencia].minimo) === 'string') ? parseString(exigencias[exigencia].minimo, idioma) : (exigencias[exigencia].minimo / 100)
    exigencias[exigencia].ideal_raw = (typeof (exigencias[exigencia].ideal) === 'string') ? parseString(exigencias[exigencia].ideal, idioma) : (exigencias[exigencia].ideal / 100)
    exigencias[exigencia].maximo_raw = (typeof (exigencias[exigencia].maximo) === 'string') ? parseString(exigencias[exigencia].maximo, idioma) : (exigencias[exigencia].maximo / 100)
  }
}
export const chutaKP = (state) => {
  const idioma = state.app.idioma
  const animal = state.app.animal
  const alimentos = state.app.alimentos_selecionados
  const exigencias = state.app.exigencias
  let proporcaoVC = parseInt(state.app.vc.v)

  const volumosos = alimentos.filter((val) => val.volumoso)
  const concentrados = alimentos.filter((val) => !val.volumoso)
  if (volumosos.length === 0 || concentrados.length === 0) {
    (volumosos.length === 0) ? proporcaoVC = 0 : proporcaoVC = 100
  }
  if (!state.app.fixavc) proporcaoVC = 50
  const pesoAnimal = parseString(animal.peso_corporal_medio.valor, idioma)

  const CMS = exigencias.CMS.ideal_raw
  const pesoVolumosos = CMS * (proporcaoVC / 100)
  const pesoConcentrados = CMS - pesoVolumosos

  const kpVolumoso = ((2.365 + 0.0214 * ((pesoVolumosos * 1000) / pesoAnimal) + 0.0734 * ((pesoVolumosos * 1000) / pesoAnimal) + 0.069 * pesoVolumosos) / 100)
  const kpConcentrado = ((1.169 + 0.1375 * ((pesoConcentrados * 1000) / pesoAnimal) + 0.1721 * ((pesoConcentrados * 1000) / pesoAnimal)) / 100)
  return { kpVolumoso, kpConcentrado }
}
export const calculaProporcao = (state, alimento, predicao = true) => {
  const idioma = state.app.idioma
  const MS = parseString(alimento.nutrientes['MS'], idioma)
  return ((predicao && state.app.tipo_alimento_predicao === 'MS') || !predicao) ? (1 / (MS / 100)) : 1
}
export const calculaPesoCV = (state) => {
  const idioma = state.app.idioma
  let pesoVolumosos = 0
  let pesoConcentrados = 0
  let alimentos = state.app.alimentos_selecionados

  alimentos.forEach((el) => {
    if (el.id === ID_LEITE_VACA) return
    let fator = 0
    switch (el.unidade) {
      case 'kg':
        fator = 1
        break
      case 'g':
        fator = 1000
        break
      case 'mg':
        fator = 1000000
        break
      default:
        fator = 1
    }
    let xProporcao = calculaProporcao(state, el)
    let MN = (parseString(el.quantidade === null ? 0 : el.quantidade, idioma) / fator) * xProporcao
    let peso = (MN * (parseString(el.nutrientes['MS'], idioma) / 100))
    if (el.id !== ID_LEITE_VACA) {
      el.volumoso ? pesoVolumosos += peso : pesoConcentrados += peso
    }
  })
  return { pesoConcentrados, pesoVolumosos }
}
export const calculaPCVZ = (state, animal) => {
  const idioma = state.app.idioma
  const pesoCorporalMedio = parseString(animal.peso_corporal_medio.valor, idioma)
  const tipo = animal.tipo.valor
  const raca = animal.raca.valor
  const sexo = animal.sexo.valor
  const regime = animal.regime.valor
  const estadoFisiologico = animal.estado_fisiologico.valor
  var PV = pesoCorporalMedio
  var PCJ = 0

  if (tipo === CRESCIMENTO_TERMINACAO) {
    // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
    if (raca === CRUZADO_CORTE || raca === ZEBUINO) {
      PCJ = 0.8915 * Math.pow(PV, 1.0151)
    } else if (raca === CRUZADO_LEITE) {
      PCJ = 0.9247 * Math.pow(PV, 1.0085)
    }
  } else if (tipo === VACA) {
    // -------------VACA------------------------------------------------------
    if (estadoFisiologico === LACTANTE || estadoFisiologico === GESTANTE_LACTANTE) {
      PCJ = 0.8915 * Math.pow(PV, 1.0151)
    } else {
      PCJ = 0.8084 * Math.pow(PV, 1.0303)
    }
  } else if (tipo === BEZERRO) {
    // -------------BEZERRO------------------------------------------------------
    PCJ = PV
  }
  // --------------------------------------------------------------------------------
  // ----------------------------------Cálculo PCVZ ---------------------------------
  // --------------------------------------------------------------------------------

  var PCVZ = 0
  if (tipo === CRESCIMENTO_TERMINACAO) {
    // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
    if (sexo === FEMEA) {
      // ---------FEMEA---------
      if (raca === ZEBUINO) {
        PCVZ = 0.6110 * Math.pow(PCJ, 1.0667)
      } else if (raca === CRUZADO_CORTE || raca === CRUZADO_LEITE) {
        PCVZ = 0.6314 * Math.pow(PCJ, 1.0602)
      }
    } else {
      // ---------MACHO---------
      if (regime === PASTO) {
        // Zebuino/Cruzado Inteiro/Castrado no Pasto
        PCVZ = 0.8507 * Math.pow(PCJ, 1.0002)
      } else {
        if (raca === ZEBUINO) {
          if (sexo === MACHO) {
            PCVZ = 0.8126 * Math.pow(PCJ, 1.0134)
          } else if (sexo === MACHO_CASTRADO) {
            PCVZ = 0.6240 * Math.pow(PCJ, 1.0608)
          }
        } else if (raca === CRUZADO_CORTE || raca === CRUZADO_LEITE) {
          if (sexo === MACHO) {
            PCVZ = 0.7248 * Math.pow(PCJ, 1.0314)
          } else if (sexo === MACHO_CASTRADO) {
            PCVZ = 0.6586 * Math.pow(PCJ, 1.0499)
          }
        }
      }
    }
  } else if (tipo === VACA) {
    // -------------VACA------------------------------------------------------
    if (estadoFisiologico === LACTANTE || estadoFisiologico === GESTANTE_LACTANTE) {
      PCVZ = 0.8507 * Math.pow(PCJ, 1.0002)
    } else {
      PCVZ = 0.8424 * Math.pow(PCJ, 1.0122)
    }
  } else if (tipo === BEZERRO) {
    // -------------BEZERRO------------------------------------------------------
    PCVZ = 0.962 * PCJ
  }

  // -----------------------------------------------------------------------------------
  // ----------------------------------Cálculo PCVZeq ----------------------------------
  // -----------------------------------------------------------------------------------

  var PCVZeq = 0
  if (tipo === CRESCIMENTO_TERMINACAO) {
    // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
    // -----FÊMEA-----
    if (sexo === FEMEA) {
      if (raca === ZEBUINO) {
        PCVZeq = (PCVZ / 402) * 517
      } else if (raca === CRUZADO_CORTE) {
        PCVZeq = (PCVZ / 417) * 517
      } else if (raca === CRUZADO_LEITE) {
        PCVZeq = (PCVZ / 493) * 517
      }
      // -----MACHO-----
    } else {
      if (raca === ZEBUINO) {
        if (sexo === MACHO) {
          PCVZeq = (PCVZ / 517) * 517
        } else if (sexo === MACHO_CASTRADO) {
          PCVZeq = (PCVZ / 433) * 517
        }
      } else if (raca === CRUZADO_CORTE) {
        if (sexo === MACHO) {
          PCVZeq = (PCVZ / 560) * 517
        } else if (sexo === MACHO_CASTRADO) {
          PCVZeq = (PCVZ / 482) * 517
        }
      } else if (raca === CRUZADO_LEITE) {
        if (sexo === MACHO) {
          PCVZeq = (PCVZ / 616) * 517
        } else if (sexo === MACHO_CASTRADO) {
          PCVZeq = (PCVZ / 532) * 517
        }
      }
    }
  }
  return { PCVZ, PCVZeq }
}
export const calculaKmKg = (state, PCVZeq, GPCVZ) => {
  const animal = state.app.animal
  const tipo = animal.tipo.valor
  const raca = animal.raca.valor
  const regime = animal.regime.valor
  // --------------------------------------------------------------------------------
  // ----------------------------------Cálculo ERp ----------------------------------
  // --------------------------------------------------------------------------------

  var ERp = 0
  if (tipo === CRESCIMENTO_TERMINACAO) {
    var ER = 0.061 * Math.pow(PCVZeq, 0.75) * Math.pow(GPCVZ, 1.035)
    ERp = (1.14 * Math.pow(ER / GPCVZ, -1.137))
  }
  // --------------------------------------------------------------------------------
  // ----------------------------------Cálculo kg ----------------------------------
  // --------------------------------------------------------------------------------
  var kg = 0
  kg = 0.327 / (0.539 + ERp)
  // --------------------------------------------------------------------------------
  // ----------------------------------Cálculo km ----------------------------------
  // --------------------------------------------------------------------------------
  var km = 0
  if (tipo === CRESCIMENTO_TERMINACAO) {
    // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
    if (regime === PASTO) {
      km = (0.513 + 0.173 * kg + 0.1 * GPCVZ) * 0.92
    } else if (raca === ZEBUINO) {
      km = 0.513 + 0.173 * kg + 0.1 * GPCVZ
    } else if (raca === CRUZADO_CORTE) {
      km = 0.513 + 0.173 * kg + 0.073 * GPCVZ
    } else if (raca === CRUZADO_LEITE) {
      km = 0.513 + 0.173 * kg + 0.01 * GPCVZ
    }
  }
  return { km, kg }
}
export var parseString = (valor, idioma) => {
  if (typeof valor === 'number') return valor
  if ((idioma === 0 || idioma === 2) && valor && valor !== '-') {
    if (valor[valor.length - 3] === '.' || valor[valor.length - 2] === '.') return parseFloat(valor)
    return parseFloat(valor.replace(/[.]/g, '').replace(/[,]/g, '.'))
  } else if (idioma === 1 && valor && valor !== '-') {
    if (valor[valor.length - 3] === ',' || valor[valor.length - 2] === ',') return parseFloat(valor.replace(/[,]/g, '.'))
    else return parseFloat(valor)
  } else if (valor && valor !== '-') {
    return parseFloat(valor.replace(/[,]/g, ''))
  }
  return 0
}
export const parseMoney = (valor, idioma) => {
  if ((idioma === 0 || idioma === 2) && valor) {
    return parseFloat(valor.replace('R$', '').replace(/[.]/g, '').replace(/[,]/g, '.'))
  } else if (valor) {
    return parseFloat(valor.replace('U$', '').replace(/[,]/g, ''))
  }
  return 0
}
export const getFloatByObjectEN = (obj, path, defaultValue = '0', fn = parseFloat) => {
  if (!fn) fn = parseFloat;
  return _.chain(obj)
            .get(path, defaultValue)
            .replace(/[,]/g, "")
            .thru(valor => fn(valor))
            .thru(valor => isNaN(valor) ? fn(defaultValue) : valor)
            .value();
}
export const getIntByObjectEN = (obj, path, defaultValue = '0') => {
  return getFloatByObjectEN(obj, path, defaultValue, parseInt);
}
export const getFloatByObjectPT = (obj, path, defaultValue = '0', fn = parseFloat) => {
  if (!fn) fn = parseFloat;
  return _.chain(obj)
            .get(path, defaultValue)
            .replace(/[.]/g, "")
            .replace(/[,]/g, ".")
            .thru(valor => fn(valor))
            .thru(valor => isNaN(valor) ? fn(defaultValue) : valor)
            .value();
}
export const getIntByObjectPT = (obj, path, defaultValue = '0') => {
  return getFloatByObjectPT(obj, path, defaultValue, parseInt);
}
export const getData = (state, axios = null, defaultParams = {}) => {
  if (axios === null) {
    axios = Vue.prototype.axios
  }
  let cliente = JSON.parse(localStorage.getItem('cliente'))
  let param = { ...defaultParams }
  if (cliente && param['id_cliente'] === undefined) param['id_cliente'] = cliente.id
  return axios.post('data/main', param).then(response => {
    let data = response.data.data
    if (data === null) {
      localStorage.setItem('predicoes_', JSON.stringify({}))
      localStorage.setItem('dietas_', JSON.stringify({}))
      localStorage.setItem('tabelas_', JSON.stringify({}))
      state.app.predicoes = {}
      state.app.dietas = {}
      state.app.tabelas = {}
      return
    }
    try {
      let pred = data['predicoes']['data']
      let dietas = data['dietas']['data']
      state.app.predicoes = pred
      state.app.dietas = dietas
    } catch (err) {
      console.log(err)
    }
    axios.post('data/chart', param).then(res => {
      state.app.data = data
      state.app.data.chart = res.data.data
    })
  })
}
export const getDataEmpresa = (state, idempresa, axios, filters = {}) => {
  return axios.post('dieta/getFDEmpresa', { id_empresa: idempresa, filters }).then(response => {
    let data = response.data
    if (data === null) {
      localStorage.setItem('predicoes_', JSON.stringify({}))
      localStorage.setItem('dietas_', JSON.stringify({}))
      localStorage.setItem('tabelas_', JSON.stringify({}))
      state.app.predicoes = {}
      state.app.dietas = {}
      state.app.tabelas = {}
      return
    }
    try {
      let dietas = data
      // let tabelas = data_['tabelas']
      // localStorage.setItem('dietas_', JSON.stringify(dietas))
      // localStorage.setItem('tabelas_', JSON.stringify(tabelas))
      state.app.dietas = dietas
      // state.app.tabelas = tabelas
      return dietas
    } catch (err) {
      console.log(err)
    }
  })
}
export const getDataAdm = (state, axios, filters = {}) => {
  return axios.post('dieta/getFDAdm', filters).then(response => {
    let data = response.data.data.dataFD
    if (data === null) {
      localStorage.setItem('predicoes_', JSON.stringify({}))
      localStorage.setItem('dietas_', JSON.stringify({}))
      localStorage.setItem('tabelas_', JSON.stringify({}))
      state.app.predicoes = {}
      state.app.dietas = {}
      state.app.tabelas = {}
      return response.data.data
    }
    try {
      let dietas = data
      // let tabelas = data_['tabelas']
      // localStorage.setItem('dietas_', JSON.stringify(dietas))
      // localStorage.setItem('tabelas_', JSON.stringify(tabelas))
      state.app.dietas = dietas
      // state.app.tabelas = tabelas
      return response.data.data
    } catch (err) {
      console.log(err)
    }
  })
}
export const getVinculados = (state, idempresa, axios) => {
  return axios.post('empresa/getVinculados', { id_empresa: idempresa }).then(response => {
    let data = response.data
    if (data === null) {
      localStorage.setItem('vinculados_', JSON.stringify({}))
      state.app.vinculados = {}
      return
    }
    try {
      let vinculados = data
      // let tabelas = data_['tabelas']
      // localStorage.setItem('vinculados_', JSON.stringify(vinculados))
      // localStorage.setItem('tabelas_', JSON.stringify(tabelas))
      state.app.vinculados = vinculados
      // state.app.tabelas = tabelas
    } catch (err) {
      console.log(err)
    }
    return state.app.vinculados
  })
}
export const getNaoVinculados = (state, idempresa, axios) => {
  return axios.post('empresa/getNaoVinculados', { id_empresa: idempresa }).then(response => {
    let data = response.data
    if (data === null) {
      state.app.naoVinculados = {}
      return
    }
    try {
      let vinculados = data.data
      // let tabelas = data_['tabelas']
      // localStorage.setItem('vinculados_', JSON.stringify(vinculados))
      // localStorage.setItem('tabelas_', JSON.stringify(tabelas))
      state.app.naoVinculados = vinculados
      // state.app.tabelas = tabelas
    } catch (err) {
      console.log(err)
    }
    return state.app.naoVinculados
  })
}
export const getDietasNaoVinculados = (state, idempresa, axios, defaultParams = {}) => {
  let param = { ...defaultParams }
  return axios.post('empresa/getDietasNaoVinculados', { id_empresa: idempresa, filters: param }).then(response => {
    let data = response.data
    if (data === null) {
      state.app.dietasNaoVinculados = {}
      return
    }
    try {
      let vinculados = data.data
      // let tabelas = data_['tabelas']
      // localStorage.setItem('vinculados_', JSON.stringify(vinculados))
      // localStorage.setItem('tabelas_', JSON.stringify(tabelas))
      state.app.dietasNaoVinculados = vinculados
      // state.app.tabelas = tabelas
    } catch (err) {
      console.log(err)
    }
    return state.app.dietasNaoVinculados
  })
}
export const getAlimentosEmpresa = (state, idempresa, axios, areadaempresa = false) => {
  return axios.post((idempresa === null) ? 'alimentos/getAlimentosPatrocinados' : 'alimentos/getAlimentosEmpresa', (areadaempresa) ? { id_empresa: idempresa, area_da_empresa: areadaempresa } : { id_empresa: idempresa }).then(response => {
    state.app.alimentos_empresa = response.data.data
  })
}
export const getAlimentos_ = async ($store, axios, forced = true, idDieta = null) => {
  return new Promise(async (resolve, reject) => {
    axios.post('alimentos/lastUpdateAt', {}).then(async (response) => {
      let lastUpdate = parseInt(response.data.data[1])
      let tipos = JSON.parse(localStorage.getItem('tipos'))
      let alimentos = JSON.parse(localStorage.getItem('alimentos'))

      if (lastUpdate === parseInt(localStorage.getItem('lastUpdate'))) {
        $store.commit('setAlimentos', {
          tipos: tipos,
          alimentos: alimentos
        })
        await axios.post('alimentos/getListaAlimentos', { apenasUSREMP: true, id_dieta: idDieta }).then(response => {
          $store.commit('setAlimentosEmpresa', { alimentos: response.data.data['emp'] })
          $store.commit('setAlimentosUsuario', { alimentos: response.data.data['usr'] })
          localStorage.setItem('alimentos_emp', JSON.stringify(response.data.data['emp']))
        }).finally(() => {
        })
        resolve(alimentos)
      } else {
        axios.post('tipos', {}).then(response => {
          let tipos = response.data.data
          localStorage.setItem('tipos', JSON.stringify(tipos))
          axios.post('alimentos/getListaAlimentos', { id_dieta: idDieta }).then(response => {
            localStorage.setItem('alimentos', JSON.stringify(response.data.data['brcorte']))
            $store.commit('setAlimentos', {
              tipos: tipos,
              alimentos: response.data.data['brcorte']
            })
            $store.commit('setAlimentosEmpresa', { alimentos: response.data.data['emp'] })
            $store.commit('setAlimentosUsuario', { alimentos: response.data.data['usr'] })
            localStorage.setItem('lastUpdate', lastUpdate)
            $store.commit('getDefaultLeiteVaca')
            resolve(response.data.data['brcorte'])
          }).catch(error => {
            reject(new Error(error))
          })
        }).finally(() => {
        })
      }
    }).catch(reason => {
      reject(new Error(reason))
    })
  })
}

export const getAlimentos = async ($store, axios, forced = true, idDieta = null) => {
  return new Promise(async (resolve, reject) => {
    return $store.dispatch('getAlimentos', { idDieta, forced }).then(resolve).catch(reject)
  })
}
export const getAcessoModulo = ({ user, modulo }) => getAcessoModuloAction(null, { user, modulo })
export const gerarRelatorioFinanceiro = (animal, custo) => relatorioFinanceiro({}, { animal, custo })
export default {
  store,
  install (Vue, _options) {
    Vue.prototype.store = store
    const strings = Vue.prototype.store.state.app.strings
    const idioma = localStorage.getItem('idioma')
    Vue.prototype.getAcessoModulo = ({ user, modulo }) => getAcessoModuloAction(null, { user, modulo })
    Vue.prototype.gerarRelatorioFinanceiro = (animal, custo) => relatorioFinanceiro({}, { animal, custo})
    Vue.prototype.$getInfoEmpresa = (idEmpresa) => {
      return Vue.prototype.axios.post('parceiros/getInfoEmpresa', { parceiro: idEmpresa }).then(response => {
        return response.data.data
      })
    }
    Vue.prototype.moment = (...args) => {
      return moment(...args)
    }
    Vue.prototype.cadastraDadosExtras = async () => {
      const { value: formValues } = await Swal.fire({
        title: 'Preencha os dados',
        html:
          `<table>` +
          '<tr><td><label for="data_nascimento">Data de Nascimento: </label></td><td><input id="data_nascimento" class="swal2-input" type="date" label="Data de Nascimento"></td></tr>' +
          '<tr><td><label for="data_nascimento">Whatsapp: </label></td><td><input id="whatsapp" class="swal2-input"  label="Whatsapp"></td></tr>' +
          '<tr><td><label for="sexo">Sexo: </label></td><td><select id="sexo" class="swal2-input" type=""><option value="M">Masculino</option><option value="F">Feminino</option><option value="N">Não quero me identificar</option></select></td></tr>' +
          '<tr><td><label for="sexo">Perfil: </label></td><td><select id="sexo" class="swal2-input" type=""><option value="M">Masculino</option><option value="F">Feminino</option><option value="N">Não quero me identificar</option></select></td></tr>' +
          '<tr><td><label for="sexo">Como encontrou o BR-Corte? : </label></td><td><select id="sexo" class="swal2-input" type=""><option value="M">Masculino</option><option value="F">Feminino</option><option value="N">Não quero me identificar</option></select></td></tr>' +

          '</table>',
        focusConfirm: false,
        preConfirm: () => {
          return [
            document.getElementById('data_nascimento').value,
            document.getElementById('sexo').value
          ]
        }
      })

      if (formValues) {
        Swal.fire(JSON.stringify(formValues))
        return formValues
      }
    }
    Vue.prototype.alertAtualizeOsDados = () => {
      Vue.prototype.sweetAlert(strings[idioma].alert_atualize_dados).then(result => {
        if (result.isConfirmed) {
          router.push('user')
        }
      })
    }
    Vue.prototype.temDadosFaltantesUser = (user, callbackSuccess = null, callbackError = null) => {
      let res = !(user.data_nascimento && user.data_nascimento !== null && user.sexo && user.sexo !== null)
      if (res) {
        if (callbackSuccess && callbackSuccess instanceof Function) {
          callbackSuccess()
        } else {
          Vue.prototype.sweetAlert(strings[idioma].preencha_os_dados_do_usuario).then(result => {
            if (result.isConfirmed) {
              window.open('user', '_blank')
            }
          })
        }
      } else {
        if (callbackError && callbackError instanceof Function) {
          callbackError()
        }
      }
      return res
    }
    Vue.prototype.verificaDadosFaltantes = (user) => {
      localStorage.removeItem('pendente')
      if (user.data_nascimento && user.data_nascimento !== null && user.sexo && user.sexo !== null) return false
      localStorage.setItem('pendente', true)

      Vue.prototype.sweetAlert({
        title: strings[idioma].atualize_seus_dados,
        text: strings[idioma].atualizacao_necessaria,
        icon: 'warning',
        confirmButtonText: strings[idioma].ok_quero_atualizar,
        showCancelButton: true,
        cancelButtonText: strings[idioma].atualizar_mais_tarde
      }).then((result) => {
        if (result.isConfirmed) {
          router.push('user')
        }
      })
    }
    Vue.prototype.voltar = () => {
      window.history.back()
    }
    Vue.prototype.rand = () => {
      return String(Math.random())
    }
    Vue.prototype.$getAditivos = () => {
      return Vue.prototype.axios.post('aditivos/getAditivos').then(r => {
        this.aditivos = r.data.data
        let ing = this.aditivos.map(a => {
          let res = {}
          res['id'] = 'AD|' + a.id
          res['fator'] = a.fator
          res['sigla'] = a.sigla !== '' ? a.sigla : res['id']
          res['exigencia'] = a.nome
          res['exigencia_en'] = a.nome_ingles
          res['exigencia_es'] = a.nome_espanhol
          res['unidade'] = a.unidade
          res['unidade_en'] = a.unidade
          res['unidade_es'] = a.unidade
          return res
        })
        return ing
      })
    }
    Vue.prototype.$limpaLocalStorage = () => {
      return limpaLocalStorage()
    }
    Vue.prototype.$alert = function (msg, type) {
      window.$ = window.jQuery = require('jquery')
      $(document).ready(function () {
        $('#alert_body').html(msg)

        $('#alert_box').removeClass('alert-success')
        $('#alert_box').removeClass('alert-danger')
        $('#alert_box').addClass('alert-' + type)
        $('#alert_box').addClass('text-center')
        $('#alert_box').show()
        setTimeout(function () {
          $('#alert_box').hide()
        }, 2000)
      })
    }
    Vue.prototype.$formatCnpjCpf = (value) => {
      const cnpjCpf = value.replace(/\D/g, '')

      if (cnpjCpf.length === 11) {
        return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '\$1.\$2.\$3-\$4')
      }

      return cnpjCpf.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '\$1.\$2.\$3/\$4-\$5')
    }
    Vue.prototype.$testaCNPJ = (cnpj) => {
      cnpj = cnpj.replace(/[^\d]+/g, '')

      if (cnpj === '') return false

      if (cnpj.length !== 14) { return false }

      // Elimina CNPJs invalidos conhecidos
      if (cnpj === '00000000000000' ||
          cnpj === '11111111111111' ||
          cnpj === '22222222222222' ||
          cnpj === '33333333333333' ||
          cnpj === '44444444444444' ||
          cnpj === '55555555555555' ||
          cnpj === '66666666666666' ||
          cnpj === '77777777777777' ||
          cnpj === '88888888888888' ||
          cnpj === '99999999999999') { return false }

      // Valida DVs
      let tamanho = cnpj.length - 2
      let numeros = cnpj.substring(0, tamanho)
      let digitos = cnpj.substring(tamanho)
      let soma = 0
      let pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) { pos = 9 }
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
      if (resultado !== parseInt(digitos.charAt(0))) { return false }

      tamanho = tamanho + 1
      numeros = cnpj.substring(0, tamanho)
      soma = 0
      pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) { pos = 9 }
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
      if (resultado !== parseInt(digitos.charAt(1))) { return false }
      return true
    }
    Vue.prototype.$validateEmail = (email) => {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
    Vue.prototype.$errorModal = function (title, errors) {
      window.$ = window.jQuery = require('jquery')
      var elm = 'Foram encontrados os seguintes erros:<ul>'
      $(document).ready(function () {
        errors.forEach(function (_e, i, errors) {
          elm += '<li>' + errors[i] + '</li>'
        })

        elm += '</ul>'
        $('#errors_modal_title').text(title)
        $('#errors_modal_body').html(elm)

        $('#errors_modal').modal()
      })
    }
    Vue.prototype.$validatePrice = function (evt) {
      var theEvent = evt || window.event
      if (theEvent.type === 'paste') {
        key = event.clipboardData.getData('text/plain')
      } else {
        // Handle key press
        var key = theEvent.keyCode || theEvent.which
        key = String.fromCharCode(key)
      }

      var regex = /[0-9]|\.|,/
      if (!regex.test(key)) {
        theEvent.returnValue = false
        if (theEvent.preventDefault) theEvent.preventDefault()
      }
      // return key.replace(',','.');
    }
    Vue.prototype.$priceComma = function (evt) {
      evt = evt || window.event
      evt = evt.target || evt.srcElement
      var price = evt.value
      evt.value = price.replace(',', '.')
      return evt.value
    }
    Vue.prototype.$validateOnlyNumbers = function (evt, float = false, idioma = 0) {
      var theEvent = evt || window.event
      var key = null
      var regex = (float) ? ((idioma === 0) ? /[0-9 | ,]/ : /[0-9 | .]/) : /[0-9]/
      // Handle paste
      if (theEvent.type === 'paste') {
        key = theEvent.clipboardData.getData('text/plain').trim()
        for (let k of key) {
          if (!regex.test(k)) {
            theEvent.returnValue = false
            if (theEvent.preventDefault) theEvent.preventDefault()
          }
        }
      } else {
        // Handle key press
        key = theEvent.keyCode || theEvent.which
        key = String.fromCharCode(key)
      }
      if (!regex.test(key) && theEvent.target) {
        var inp = theEvent.target
        if (idioma === 0) {
          setTimeout(function () {
            inp.value = ''
          }, 0)
        }
        theEvent.returnValue = false
        if (theEvent.preventDefault) theEvent.preventDefault()
      }
    }

    // O cálculo do dígito verificador ainda é feito manualmente, pois lodash não fornece função específica para CPF.
    Vue.prototype.$testaCPF = function (strCPF) {
      strCPF = _.replace(strCPF, /[^\d]+/g, '');
      if (_.size(strCPF) !== 11 || _.every(['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'], v => v === strCPF)) {
        return false;
      }
      let soma = 0;
      for (let i = 1; i <= 9; i++) soma += _.toInteger(strCPF.substring(i - 1, i)) * (11 - i);
      let resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== _.toInteger(strCPF.substring(9, 10))) return false;
      soma = 0;
      for (let i = 1; i <= 10; i++) soma += _.toInteger(strCPF.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== _.toInteger(strCPF.substring(10, 11))) return false;
      return true;
    }
    Vue.prototype.$validateEmail = function (email) {
      var re = /\S+@\S+\.\S+/
      return re.test(email)
    }
    Vue.prototype.$dataTableRegister = function (idStr) {
      $(document).ready(function () {
        $(idStr).DataTable({
          'language': {
            'sEmptyTable': 'Não foi encontrado nenhum registro',
            'sLoadingRecords': 'Carregando...',
            'sProcessing': 'Processando...',
            'sLengthMenu': 'Mostrar _MENU_ registros',
            'sZeroRecords': 'Não foram encontrados resultados',
            'sInfo': 'Mostrando de _START_ até _END_ de _TOTAL_ registos',
            'sInfoEmpty': 'Mostrando de 0 até 0 de 0 registos',
            'sInfoFiltered': '(filtrado de _MAX_ registos no total)',
            'sInfoPostFix': '',
            'sSearch': 'Buscar:',
            'sUrl': '',
            'oPaginate': {
              'sFirst': 'Primeiro',
              'sPrevious': 'Anterior',
              'sNext': 'Seguinte',
              'sLast': 'Último'
            },
            'oAria': {
              'sSortAscending': ': Ordenar colunas de forma ascendente',
              'sSortDescending': ': Ordenar colunas de forma descendente'
            }
          }
        })
      })
    }
    Vue.prototype.$parseString = (valor, idioma) => {
      if (typeof valor === 'number') return valor
      if ((idioma === 0 || idioma === 2) && valor) {
        if (valor[valor.length - 3] === '.') return parseFloat(valor)
        return parseFloat(valor.replace(/[.]/g, '').replace(/[,]/g, '.'))
      } else if (valor) {
        return parseFloat(valor.replace(/[,]/g, ''))
      }
      return 0
    }
    Vue.prototype.$parseMoney = (valor, idioma) => {
      if ((idioma === 0 || idioma === 2) && valor) {
        return parseFloat(valor.replace('R$', '').replace(/[.]/g, '').replace(/[,]/g, '.'))
      } else if (valor) {
        return parseFloat(valor.replace('U$', '').replace(/[,]/g, ''))
      }
      return 0
    }
    Vue.prototype.$parsePorcentagem = (valor, idioma) => {
      if ((idioma === 0 || idioma === 2) && valor) {
        return parseFloat(valor.replace('%', '').replace(/[.]/g, '').replace(/[,]/g, '.'))
      } else if (valor) {
        return parseFloat(valor.replace('%', '').replace(/[,]/g, ''))
      }
      return 0
    }
    Vue.prototype.$sortObject = (obj) => {
      let values = Object.values(obj).sort((a, b) => {
        return a.valor > b.valor ? -1 : a.valor < b.valor ? 1 : 0
      })
      obj = {}
      values.forEach(el => { obj[el.id] = el })
      return obj
    }
    Vue.prototype.$escapeRegExp = (text) => {
      return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
    }
    Vue.prototype.$replaceSpecialChars = (str) => {
      str = str.replace(/[ÀÁÂÃÄÅ]/, 'A')
      str = str.replace(/[àáâãäå]/, 'a')
      str = str.replace(/[ÈÉÊË]/, 'E')
      str = str.replace(/[èéê]/, 'e')
      str = str.replace(/[ìíî]/, 'i')
      str = str.replace(/[ÌÍÎ]/, 'I')
      str = str.replace(/[òóô]/, 'o')
      str = str.replace(/[ÒÓÔ]/, 'O')
      str = str.replace(/[ùúûü]/, 'u')
      str = str.replace(/[ÙÚÛÜ]/, 'U')
      str = str.replace(/[Ç]/, 'C')
      str = str.replace(/[ç]/, 'c')
      str = str.replace(/[Ñ]/, 'N')
      str = str.replace(/[ñ]/, 'n')

      // o resto

      return str.replace(/[^a-z0-9]/gi, '')
    }
    Vue.prototype.$onlyFloat = (evt, input, tipo, idioma = 0) => {
      let curStart = evt.target.selectionStart
      let curEnd = evt.target.selectionEnd
      let cursor = -1
      evt.preventDefault()
      if (evt.target.isComposing || evt.target.keyCode === 229) {
        return
      }
      let key = evt.key
      key = ((idioma === 0 || idioma === 2) && key === '.') ? ',' : (idioma === 1 && key === ',') ? '.' : key
      var regex = (idioma === 0 || idioma === 2) ? /[0-9 | ,]/ : /[0-9 | .]/
      // valida se valor digitado é número ou separador
      if (regex.test(key)) {
        if (input[tipo] === undefined) { input[tipo] = key }
        if (key === '0' && input[tipo] === '0') return
        if (key === ((idioma === 0) ? ',' : '.')) {
          input[tipo] = Vue.prototype.$parseString(input[tipo], idioma).toFixed(0)
          curStart = input[tipo].length
          curEnd = input[tipo].length
        }
        if (key !== ((idioma === 0) ? ',' : '.') && input[tipo] === '0') input[tipo] = ''
        if ((curEnd > curStart) || (curEnd === curStart && (input[tipo] === null || curEnd < input[tipo].length))) {
          let aux = input[tipo] === null ? '' : (typeof input[tipo] === 'string') ? input[tipo] : String(input[tipo])
          input[tipo] = aux.substring(0, curStart)
          if ((input[tipo] === null || input[tipo].length === 0) && key === ((idioma === 0) ? ',' : '.')) {
            input[tipo] = '0'
          }
          input[tipo] += key
          cursor = input[tipo].length
          input[tipo] += aux.substring(curEnd)
        } else {
          input[tipo] += key
          cursor = input[tipo].length
        }
        setTimeout(function () {
          evt.target.selectionStart = cursor
          evt.target.selectionEnd = cursor
          evt.target.focus()
        }, 10)
      }
    }
    Vue.prototype.$limpezaDeDados = (input, tipo = 0, fn = null, args = null, idioma) => {
      tipo = Math.abs(tipo)
      if (input.valor === '') return

      input.valor = (idioma === 0 || idioma === 2) ? Vue.prototype.$parseString(input.valor, idioma).toFixed(tipo).replace('.', ',') : Vue.prototype.$parseString(input.valor, idioma).toFixed(tipo)
      if (input.valor.trim() !== '' && isNaN(Vue.prototype.$parseString(input.valor, idioma))) input.valor = (0).toFixed(0)
      if (fn !== null) {
        if (args === null) {
          args = [input]
        }
        fn(...args)
      }
    }
    Vue.prototype.sweetAlert = (...args) => {
      return Swal.fire(...args)
    }
    async function conf (state, msg) {
      return new Promise((resolve) => {
        let res = null
        state.app.modal.active = true
        state.app.modal.msg = msg
        state.app.modal.optionsType = 'YN'
        state.app.modal.title = ''
        state.app.modal.msg = msg
        state.app.modal.error = ''
        state.app.modal.responseCallback = (r) => {
          res = r
          resolve(res)
        }
        state.app.modal.active = true
      })
    }
    Vue.prototype.$confirm = (state, msg, fn = null, args = null) => {
      let res = (async () => {
        res = await conf(state, msg)
        return res
      })()
      return res
    },
    Vue.prototype.getFloatByObject = (obj, path, defaultValue = '0') => {
      const idioma = parseInt(_.get(this, 'store.app.idioma', 0)) 
      return idioma === 1 ? getFloatByObjectEN(obj, path, defaultValue) : getFloatByObjectPT(obj, path, defaultValue)
    }
    Vue.prototype.getIntByObject = (obj, path, defaultValue = '0') => {
      const idioma = parseInt(_.get(this, 'store.app.idioma', 0)) 
      return idioma === 1 ? getIntByObjectEN(obj, path, defaultValue) : getIntByObjectPT(obj, path, defaultValue)
    },
    Vue.prototype.getString = (key, idioma_ = null) => {
      if (!idioma_ && _.isNil(_.get(this, 'store.app.idioma', null))) {
        return getString(key)
      }
      const idioma = (idioma_) ? parseInt(idioma_) : parseInt(_.get(this, 'store.app.idioma', 0)) 
      return getString(key, idioma)
    },
    Vue.prototype.sejaPremium = () => {
      Vue.prototype.$premiumAlert.show({
        icon: '👑',
        modalTitle: getString('premium_conteudo_bloqueado_titulo'),
        msg: getString('funcionalidade_exclusiva_premium')
      })
    }
    Vue.prototype.sejaPremiumCompartilhamento = () => {
      Vue.prototype.$premiumAlert.show({
        icon: '🔒',
        modalTitle: getString('voce_esta_com_acesso_limitado'),
        msg: getString('seja_premium_edite_compartilhadas'),
      })
    }
  }

}
